import * as Layout from './Layout/Layout.css';
import * as RefundCreate from './RefundCreate/RefundCreate.css';
import * as RefundDocuments from './RefundDocuments/RefundDocuments.css';
import * as RefundReasons from './RefundReasons/RefundReasons.css';
import * as RefundRequest from './RefundRequest/RefundRequest.css';
export default {
    Layout,
    RefundReasons,
    RefundDocuments,
    RefundCreate,
    RefundRequest
};
